<form id="loginForm" [formGroup]="loginForm" (ngSubmit)="login()">
  <div class="auth">
    <label for="email" class="outside-window">Email</label>
    <input
      id="email"
      formControlName="email"
      type="email"
      class="auth-container"
      placeholder="Email"
      [ngClass]="{ 'is-invalid': isSubmitted && email.invalid }" />
  </div>
  <div class="error-msg">
    @if (isSubmitted && email.errors?.['required']) {
      <span class="error-text">Email requis</span>
    }
    @if (isSubmitted && email.errors?.['pattern']) {
      <span class="error-text">Format d'email invalide</span>
    }
  </div>

  <div class="auth">
    <div>
      <label for="password" class="outside-window">Mot de passe</label>
      <div class="password-input-wrapper">
        <input
          id="password"
          formControlName="password"
          [type]="passwordVisible ? 'text' : 'password'"
          class="auth-container"
          placeholder="Mot de passe"
          [ngClass]="{ 'is-invalid': isSubmitted && password.invalid }" />
        <button
          type="button"
          class="toggle-password-visibility"
          (click)="togglePasswordVisibility('password')"
          aria-label="Afficher/Masquer le mot de passe">
          @if (passwordVisible) {
            <img ngSrc="assets/eye.svg" alt="Masquer le mot de passe" fill />
          } @else {
            <img ngSrc="assets/eye-slash.svg" alt="Afficher le mot de passe" fill />
          }
        </button>
      </div>
    </div>
  </div>
  <div class="error-msg">
    @if (isSubmitted && password.errors?.['required']) {
      <span class="error-text">Mot de passe requis</span>
    }
    @if (isSubmitted && (password.errors?.['pattern'] || password.errors?.['minlength'])) {
      <div class="error-box">
        <p class="error-title">Le mot de passe doit contenir 12 caractères minimum :</p>
        <ul class="error-list">
          <li>Au moins une majuscule</li>
          <li>Au moins une minuscule</li>
          <li>Au moins un chiffre</li>
          <li>Au moins un caractère spécial (&#64; $ ! % * ? &amp; #)</li>
        </ul>
      </div>
    }
  </div>

  <div class="forgot-password">
    <a href="#" (click)="$event.preventDefault(); onForgotPassword()" class="link">Mot de passe oublié ?</a>
  </div>

  <div class="auth submit-section">
    <button type="submit" class="button-component" id="login">Se connecter</button>
  </div>

  <div class="auth">
    <p>Vous n'avez pas de compte ? <a href="#" (click)="$event.preventDefault(); onOpenRegister()" class="link">Créer un compte</a></p>
  </div>

  <div class="git">
    <div class="separator-text">
      <span>OU</span>
    </div>
    <a href="javascript:void(0)" (click)="loginWithGitHub()" class="button-component centered-git-flex">
      <img src="assets/github.svg" alt="GitHub" class="github-icon" />
      Continuer avec GitHub
    </a>
  </div>
</form>
